import { createSelector } from 'reselect';

const getCountries = (state) => state.countries;
const getSelectedCountry = (state) => state.countries.countryFilter;

export const getCountryFilterDropdownOpen = ({
  countries: { countryFilterDropdownOpen }
}) => countryFilterDropdownOpen;

/*** Memoized Selectors ***/
export const allCountries = createSelector([getCountries], (countries) =>
  countries.countries.map(({ country_code, name }) => ({
    country_code,
    name
  }))
);

export const countriesDropdown = createSelector([getCountries], (countries) =>
  countries.countries.map(({ country_code, name }) => ({
    value: country_code,
    name
  }))
);

export const getCountryFilterCode = getSelectedCountry;



// WEBPACK FOOTER //
// ./src/actions/travelSecurity/countries/selectors.js